<template>
  <div v-if="clientsModificationsRelations.length > 0" class="client-select-modification--container mrg-t-10 no-select">
    <div class="input-block">
      <label for="">Модификация клиента</label>
      <select v-model="modificationId">
        <option value="0">без модификации</option>
        <option
          v-for="item in clientsModificationsRelations"
          :key="item.id"
          :value="item.clientModification.id"
        >
          {{ item.clientModification.name }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>

export default {
  name: "ClientSelectModification",
  components: {  },
  data() {
    return {
      modificationId: 0
    };
  },
  props: {
    clientsModificationsRelations: Array,
    value: Number|String
  },
  watch: {
    value: function(val) {
      this.modificationId = val;
    },
    modificationId: function(val){
      this.$emit("input", val);
    },
    clientsModificationsRelations: function(val){
      let existsModification = false;
      if(this.modificationId > 0){
        for(let key in val){
          if(+val[key].clientModification.id === +this.modificationId){
            existsModification = true;
          }
        }
      }
      if(!existsModification){
        this.modificationId = 0;
      }
    }
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {

  },
  created() {
    if(this.value){
      this.modificationId = this.value;
    }
  }
};
</script>

<style scoped lang="less">


</style>
